import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(value => (value + 1) % recentBuyers.length);
          show(GAP);
        }, VISIBLE_FOR);
      }, delay);
    };
    show(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const minutes = index * 7 % 23 + 2;
  return <div className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" aria-live="polite" data-id="element-346" data-mp="24rhbu3syluyi">
      <AnimatePresence data-id="element-347" data-mp="29nplx2sauxyt">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-[270px] items-center gap-3 rounded-2xl border-[3px] border-blue-950 bg-amber-300 p-3 pr-8 shadow-xl shadow-blue-950/25" role="status" data-id="element-348" data-mp="2ehk9ihb0zx36">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-950" data-id="element-349" data-mp="1312d2h7fhugj">
              <ShoppingBagIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-350" data-mp="v04jwqu3yheq" />
            </span>
            <p className="text-xs leading-snug text-blue-950" data-id="element-351" data-mp="q2crlvpjwta0">
              <b className="font-black" data-id="element-352" data-mp="q3xnpprikk9z">{buyer.name}</b> from{' '}
              <b className="font-black" data-id="element-353" data-mp="150exwdnyvsuy">{buyer.place}</b> just bought{' '}
              <b className="font-black" data-id="element-354" data-mp="zzhdrvjecoqt">Clear the Clutter™</b>
              <span className="mt-0.5 block font-semibold text-blue-950/70" data-id="element-355" data-mp="1dzigzhn4w89g">
                {minutes} minutes ago · Verified
              </span>
            </p>
            <button onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded p-0.5 text-blue-950/70 transition-colors duration-150 ease-out hover:text-blue-950" aria-label="Close notification" data-id="element-356" data-mp="18zw2l4vkklz2">
              <XIcon className="h-3.5 w-3.5" data-id="element-357" data-mp="1wp8ck6yq0y2f" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}